<template>
  <div>
    <div>
      <div class="d-flex align-center">
        <v-icon left>mdi-format-list-bulleted</v-icon>
        <span class="font-18 font-weight-medium">Lista de Produtos</span>

        <EditorMultiplosProdutos
          :produtos_selecionados="produtos_selecionados"
          @cadastro:estoque-min="produtos_selecionados = []; callbackResetarDadosGrid()"
        />

        <v-spacer />

        <div class="w-400">
          <v-text-field
            v-model="pesquisa"
            append-icon="mdi-magnify"
            label="Pesquisar"
            @change="buscarProdutosAposDelay()"
            @keyup.enter="buscarProdutosPeloEnter()"
          />
        </div>
      </div>
    </div>

    <SysDataTableExpand
      ref="sysDataTableAnaliseParametrosProdutoRef"
      v-model="produtos_selecionados"
      :height="altura_janela - 190"
      :item-height="45"
      :headers="CABECALHOS_COMPUTED"
      :itemClass="cssLinha"
      show-select
      :callbacks="CALLBACK_COMPUTED"
      @recolher="recolher"
      @callback-executada="callbackExecutada"
      @callback-resetar-grid="fn => callbackResetarDadosGrid = fn"
      @click:th="() => abrir_dialog_ordenacao_count++"
    >
<!--      <template #top>-->
<!--        <Ordenacao-->
<!--          id_unico_preferencia="TABELA-ANALISE-PARAMETROS-PRODUTO"-->
<!--          :itens="colunas_ordenacao"-->
<!--          :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"-->
<!--          @update:ordenacao="callbackResetarDadosGrid()"-->
<!--          @campos:ordenacao="atualizarCamposOrdenados"-->
<!--        />-->
<!--      </template>-->

      <template v-for="(item, key) in campos_em_ordenacao" #[`header.${item.campo}.icon_order`]>
        <span :key="key">
          <v-icon v-if="item.ordem === 'DECRESCENTE'" small v-text="'mdi-arrow-down'" />
          <v-icon v-else small v-text="'mdi-arrow-up'" />
        </span>
      </template>

      <template #_item.descricao_analise="{ item }">
        <div class="d-flex align-center" style="width: 290px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
          <DetalhesProduto
            v-if="item.idproduto && !item.produto_combinado"
            :produto="{
              id_grupo: item.id_grupo,
              id_filial: item.filial ? item.filial : 9999,
              id_fornecedor: item.idfornecedor,
              id_produto: item.idproduto
            }"
          />
          <span v-text="item.descricao_analise" class="text-truncate" :title="item.descricao_analise" />
        </div>
      </template>

      <template #item.estoque_min="{ item }">
        <EditorEstoqueMinimoLinha v-if="item.idproduto && item.filial" :produto="item" />
      </template>

      <template v-slot:item.data-table-select-td="{ select, isSelected, item}">
        <v-checkbox
          :input-value="isSelected"
          :class="classCheckbox(item)"
          @change="select(select)"
          @click="selectClick(item)"
          color="primary"
          class="ml-n1"
          hide-details
        />
      </template>
    </SysDataTableExpand>
  </div>
</template>

<script setup>
import { useResize } from "@/helpers/Resize";
import { computed, ref, watch } from "vue";
import {formatarValor, formatarValorComCasas} from "@/helpers";
import api from "@/api/api";
import store from "@/store";
import EditorEstoqueMinimoLinha from "@/components/drp/AnaliseParametrosProdutoDrp/EstoqueMinimo/EditorLinha.vue";
import EditorMultiplosProdutos from "@/components/drp/AnaliseParametrosProdutoDrp/EstoqueMinimo/EditorMultiplosProdutos.vue";
import SysDataTableExpand from '@/components/utils/dataTable/sysDataTableExpand/Index.vue'
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";

const { altura_janela } = useResize();

const cabecalhos = [
  { text: 'Descrição Analise', value: 'descricao_analise' },
  { text: 'Estoque', value: 'estoque' },
  { text: 'Estoque de Segurança', value: 'esseg_drp' },
  { text: 'Ponto de Pedido', value: 'tp_drp' },
  { text: 'Estoque Máximo', value: 'emax_drp' },
  { text: 'Projeção de Vendas', value: 'cmm' },
  { text: 'Desvio Padrão do Consumo', value: 'std_cmm' },
  { text: 'Cobertura de Estoque', value: 'cobertura_drp', sufix: 'dias' },
  { text: 'Estoque Mínimo', value: 'estoque_min' },
  { text: 'Sugestão', value: 'sugestao_drp' },
];
const colunas_ordenacao = [
  { descricao: 'Descrição Analise', campo: 'descricao_analise' },
  { descricao: 'Estoque', campo: 'estoque', numerico: true },
  { descricao: 'Estoque de Segurança', campo: 'esseg_drp', numerico: true },
  { descricao: 'Ponto de Pedido', campo: 'tp_drp', numerico: true },
  { descricao: 'Estoque Máximo', campo: 'emax_drp', numerico: true },
  { descricao: 'Projeção de Vendas', campo: 'cmm', numerico: true },
  { descricao: 'Desvio Padrão do Consumo', campo: 'std_cmm', numerico: true },
  { descricao: 'Cobertura de Estoque', campo: 'cobertura_drp', sufix: 'dias', numerico: true },
  { descricao: 'Estoque Mínimo', campo: 'estoque_min', numerico: true },
  { descricao: 'Sugestão', campo: 'sugestao_drp', numerico: true },
];
const campos_em_ordenacao = ref([]);
const pesquisa = ref("");
const callbackResetarDadosGrid = ref(null);
const linhas_atuais = ref([]);
const produtos_selecionados = ref([]);
const timer_delay_busca_produtos = ref();
const abrir_dialog_ordenacao_count = ref(0);
const CABECALHOS_COMPUTED = computed(() => cabecalhos);
const GRUPO_COMPRAS = computed(() => store.getters['usuario/getGrupoCompras']);
const CALLBACK_COMPUTED = computed(() => {
  let callbacks = [
    buscarDepartamentos,
    buscarSecoes,
    buscarFornecedores,
    buscarProdutos,
    buscarFiliais
  ];

  return callbacks;
});

async function buscarDepartamentos() {
  const params = { pesquisa: pesquisa.value };
  const linhas = await api.get('drp/analise-parametros-produto/departamentos', { params });
  return formatarLinhas(linhas.data.departamentos);
}

async function buscarSecoes(linha) {
  const params = {
    pesquisa: pesquisa.value,
    iddepartamento: linha.iddepartamento
  };
  const linhas = await api.get('drp/analise-parametros-produto/secoes', { params });
  return formatarLinhas(linhas.data.secoes);
}

async function buscarFornecedores(linha) {
  const params = {
    pesquisa: pesquisa.value,
    iddepartamento: linha.iddepartamento,
    idsecao: linha.idsecao
  };
  const linhas = await api.get('drp/analise-parametros-produto/fornecedores', { params });
  return formatarLinhas(linhas.data.fornecedores);
}

async function buscarProdutos(linha) {
  const params = {
    pesquisa: pesquisa.value,
    iddepartamento: linha.iddepartamento,
    idsecao: linha.idsecao,
    idfornecedor: linha.idfornecedor,
    idgrupo: GRUPO_COMPRAS.value
  };
  const linhas = await api.get('drp/analise-parametros-produto/produtos', { params });
  return formatarLinhas(linhas.data.produtos);
}

async function buscarFiliais(linha) {
  const params = {
    pesquisa: pesquisa.value,
    iddepartamento: linha.iddepartamento,
    idsecao: linha.idsecao,
    idfornecedor: linha.idfornecedor,
    idproduto: linha.idproduto,
    idgrupo: GRUPO_COMPRAS.value
  };
  const linhas = await api.get('drp/analise-parametros-produto/filiais', { params });
  return formatarLinhas(linhas.data.filiais);
}

function buscarProdutosAposDelay() {
  produtos_selecionados.value = [];
  clearTimeout(timer_delay_busca_produtos.value);
  timer_delay_busca_produtos.value = setTimeout(callbackResetarDadosGrid.value(), 2000);
}

function buscarProdutosPeloEnter() {
  clearTimeout(timer_delay_busca_produtos.value);
  callbackResetarDadosGrid.value();
}

function formatarLinhas(linhas) {
  return linhas.map(linha => {
    linha.estoque = formatarValor(linha.estoque);
    linha.esseg_drp = formatarValor(linha.esseg_drp);
    linha.tp_drp = formatarValor(linha.tp_drp);
    linha.emax_drp = formatarValor(linha.emax_drp);
    linha.cmm = formatarValor(linha.cmm);
    linha.cobertura_drp = formatarValorComCasas(linha.cobertura_drp, 0);
    linha.estoque_min = formatarValor(linha.estoque_min);
    linha.sugestao_drp = formatarValor(linha.sugestao_drp);
    linha.std_cmm = formatarValor(linha.std_cmm);
    return linha;
  });
}

function recolher(linha) {
  produtos_selecionados.value = produtos_selecionados.value.filter(obj => !obj.index.startsWith(linha.index + '-'));
}

function callbackExecutada(ev) {
  linhas_atuais.value = ev.linhas;
  produtos_selecionados.value.forEach(f => selectClick(f));
}

function selectClick(item_clicado) {
  const jaExiste = produtos_selecionados.value.some(produto => produto.index === item_clicado.index);

  if (!jaExiste) {
    const itens_para_deselecionar = produtos_selecionados.value.filter(obj => !obj.index.startsWith(item_clicado.index + '-'));
    produtos_selecionados.value = itens_para_deselecionar;
  } else {
    const itens_para_selecionar = linhas_atuais.value.filter(obj => obj.index.startsWith(item_clicado.index + '-'));
    produtos_selecionados.value = [...produtos_selecionados.value, ...itens_para_selecionar];
  }
}

function atualizarCamposOrdenados(campos) {
  campos_em_ordenacao.value = campos;
  // $forceUpdate();
}

function cssLinha(linha) {
  return {
    // 'font-weight-bold': linha.totalizador,
    'cursor-pointer': true
  }
}

function classCheckbox(item) {
  return {
    'nivel-linha-um' : item.$nivel_linha === 1,
    'nivel-linha-dois' : item.$nivel_linha === 2,
    'nivel-linha-tres' : item.$nivel_linha === 3,
    'nivel-linha-quatro' : item.$nivel_linha === 4,
  };
}
</script>

<style scoped>
.nivel-linha-um {
  position: relative !important;
  left: 25px;
}
.nivel-linha-dois {
  position: relative !important;
  left: 55px;
}
.nivel-linha-tres {
  position: relative !important;
  left: 85px;
}
.nivel-linha-quatro {
  position: relative !important;
  left: 115px;
}
</style>

